export const P00061ModeSilence = [
  { ref: 0, label: 'P00061.params.silence.normal' },
  { ref: 1, label: 'P00061.params.silence.silence' },
];
